import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import AuthService from "../services/auth.service";
import { withRouter } from '../common/with-router';
import { Link } from "react-router-dom";

const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                This field is required!
            </div>
        );
    }
};

const matchPassword = (value, props) => {
    if (value !== props.password) {
        return (
            <div className="alert alert-danger" role="alert">
                Passwords do not match!
            </div>
        );
    }
};

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeConfirmPassword = this.onChangeConfirmPassword.bind(this);

        this.state = {
            password: "",
            confirmPassword: "",
            loading: false,
            message: "",
            loaded: false,
            success: false
        };
    }

    componentDidMount() {
        document.body.style.backgroundImage = "url('/background.jpeg')";
        document.body.style.backgroundRepeat = "no-repeat";
        document.body.style.backgroundSize = "cover";
        document.body.style.backgroundPosition = "center";
        this.setState({ loaded: true });
    }

    onChangePassword(e) {
        this.setState({ password: e.target.value });
    }

    onChangeConfirmPassword(e) {
        this.setState({ confirmPassword: e.target.value });
    }

    async handleReset(e) {
        e.preventDefault();

        this.setState({
            message: "",
            loading: true
        });

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            const queryParams = new URLSearchParams(this.props.router.location.search);
            const token = queryParams.get("token");

            if (!token) {
                this.setState({
                    loading: false,
                    message: "Missing reset token."
                });
                return;
            }

            AuthService.resetPassword(token, this.state.password).then(
                () => {
                    this.setState({
                        loading: false,
                        message: "✅ Password reset successfully. You can now log in manually.",
                        password: "",
                        confirmPassword: "",
                        success: true
                    });
                },
                error => {
                    const resMessage =
                        (error.response?.data?.message) ||
                        error.message ||
                        error.toString();

                    this.setState({
                        loading: false,
                        message: resMessage
                    });
                }
            );
        } else {
            this.setState({ loading: false });
        }
    }

    render() {
        return (
            this.state.loaded ? (
                <div className="col-md-12 w-100">
                    <div className="card card-container">
                        <div className="justify-content-center text-center">
                            <h4>Reset Your Password</h4>
                            <p>Enter your new password below.</p>
                        </div>

                        {!this.state.success && (
                            <Form
                                onSubmit={this.handleReset}
                                ref={c => { this.form = c; }}
                            >
                                <div className="form-group">
                                    <label htmlFor="password">New Password</label>
                                    <Input
                                        type="password"
                                        className="form-control"
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.onChangePassword}
                                        validations={[required]}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirm New Password</label>
                                    <Input
                                        type="password"
                                        className="form-control"
                                        name="confirmPassword"
                                        value={this.state.confirmPassword}
                                        onChange={this.onChangeConfirmPassword}
                                        validations={[required, (value) => matchPassword(value, this.state)]}
                                    />
                                </div>

                                <div className="form-group">
                                    <button
                                        className="btn btn-primary btn-block"
                                        disabled={this.state.loading}
                                    >
                                        {this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        <span>RESET PASSWORD</span>
                                    </button>
                                </div>

                                <CheckButton
                                    style={{ display: "none" }}
                                    ref={c => { this.checkBtn = c; }}
                                />
                            </Form>
                        )}

                        {this.state.message && (
                            <div className="form-group mt-3">
                                <div className={`alert ${this.state.success ? 'alert-success' : 'alert-danger'}`} role="alert">
                                    {this.state.message}
                                </div>
                            </div>
                        )}

                        <div className="col-md-12 text-right mt-3">
                            <p><Link to="/login">
                                <span style={{ color: "#022e4a" }}>Back to Login</span>
                            </Link></p>
                        </div>
                    </div>
                </div>
            ) : null
        );
    }
}

export default withRouter(ResetPassword);
